import { render } from "./AllChats.vue?vue&type=template&id=95e05292&scoped=true"
import script from "./AllChats.vue?vue&type=script&lang=js"
export * from "./AllChats.vue?vue&type=script&lang=js"

import "./AllChats.vue?vue&type=style&index=0&id=95e05292&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e05292"]])

export default __exports__